import React from 'react';
import { Dialog, DialogProps } from '@material-ui/core';

import WaxPaper from 'hcla-web-frontend-primitives/app/components/primitives/Paper/WaxPaper/WaxPaper';
import { FullScreenConsumer } from './FullScreenProvider';

function PaperComponent(props: any) {
  return (
    <WaxPaper {...props} multi />
  );
}

const FullScreenDialog = (props: DialogProps) => {
  const { children, ...others } = props;
  return (
    <FullScreenConsumer>
      {
        ({ isFull }) => (
          <Dialog
            {...others}
            PaperComponent={PaperComponent}
            disablePortal={isFull}
          >
            {children}
          </Dialog>
        )
      }
    </FullScreenConsumer>
  );
};

export default FullScreenDialog;
